import { healthStatusMeta } from '../meta';

/** A small solid RYG status dot. */
export const Dot = ({ t, size }: { t: string; size: number }) => (
  <span style={{ display: 'inline-block', width: size, height: size, borderRadius: '50%', background: healthStatusMeta(t).c, flex: 'none' }} />
);

/** RYG status pill (dot + label). `big` renders the hero-sized variant. */
export const Badge = ({ t, big }: { t: string; big?: boolean }) => {
  const m = healthStatusMeta(t);
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: big ? '6px 14px' : '3px 9px', borderRadius: 6, background: m.bg, color: m.tx, fontSize: big ? 13 : 11, fontWeight: 600, lineHeight: 1 }}>
      <Dot t={t} size={big ? 9 : 7} />{m.label}
    </span>
  );
};
